import type { SVGProps } from "react";
import omit from "@/utils/omit";

const IconRankBg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="108"
      height="102"
      viewBox="0 0 108 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      {...omit(props, ["className"])}
      className="yfm-icon-rank-bg"
    >
      <path
        d="M0 16C0 7.16345 7.16344 0 16 0H92C100.837 0 108 7.16344 108 16V74.1889C108 81.2922 103.317 87.5451 96.5003 89.543L58.5003 100.681C55.5619 101.542 52.4381 101.542 49.4997 100.681L11.4997 89.543C4.68318 87.5451 0 81.2922 0 74.189V16Z"
        fill="#22F5EE"
      />
    </svg>
  );
};

IconRankBg.displayName = "IconRankBg";

export default IconRankBg;
